$.fn.StickyMenu = function() {
  let self = this
  self.footerOffset = 100
  self.footerEl = $('.footer-gallery')

  self.find('.js-toggle-sticky-menu').click(function() {
    self.toggleClass('--sticky-menu-open')
  });

  return function() {
    $.mlmi.mobile.add(function() {
      self.footerOffset = 72
      self.footerEl = $('.footer-contact.d-md-none')
    }, function() {
      self.footerOffset = 100
      self.footerEl = $('.footer-gallery')
    })
    $(window).ScrollEvents().add(function(top) {
      if (top > self.footerEl.offset().top - self.footerOffset - $(window).height()) {
        self.addClass('--sticky-menu-hidden')
      } else {
        self.removeClass('--sticky-menu-hidden')
      }
    })
    self.find('.post-share').each(function() {
      let postShare = $(this).PostShare()
      self.find('button[aria-controls="page-share"]').on('click', function() {
        let button = $(this)
        button.attr('aria-expanded', button.attr('aria-expanded') == 'true' ? 'false' : 'true')
        postShare.toggle_expand()
        postShare.on('clicked_outside', function() {
          button.attr('aria-expanded', 'false')
        })
      })
    })
    return self
  }()
};
